import { motion } from 'framer-motion';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useFeatureFlagVariantKey } from 'posthog-js/react';
import posthog from 'posthog-js';

import { setAssessmentStep } from '../../../features/assessment/assessmentSlice';
import Modal from '../../Modal/Modal';

//Images
import watchpatImageSrc from '../../../images/sleep-study-product/watchpat-one.png';
import portalDesktop from '../../../images/portal-desktop.png';

import ReactGA from 'react-ga4';
import VersionE from './VerionE';

function Control() {
    const dispatch = useDispatch();
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <motion.div
            initial={{ opacity: 0, translateX: '20%' }}
            animate={{ opacity: 1, translateX: 0 }}
            exit={{ opacity: 0, translateX: '-20%' }}
            transition={{ ease: 'linear' }}
            className="max-w-4xl mx-auto space-y-3 lg:mt-20">
            <div className="pr-0 lg:pr-8">
                <h4 className="mb-3 font-heading text-4xl text-purple-fair lg:mb-6">
                    Quiz Results Ready
                </h4>
                <h2 className="text-lg text-gray-light lg:mb-5">
                    Based on your answers, you may be suffering from Sleep Apnea.{' '}
                    <span className="text-gem-green">We can help.</span>
                </h2>
            </div>

            <div className="flex flex-col text-sm pl-0 space-y-4 lg:space-y-0">
                <div className="text-lg space-y-2 mb-2 text-center">
                    <p className="font-bold text-white text-lg lg:text-3xl">Recommended for you:</p>
                    <p className="font-bold font-heading text-5xl text-gem-green lg:text-8xl">
                        Get a sleep study.
                    </p>
                    <img
                        src={watchpatImageSrc}
                        alt="Sleep study"
                        className="w-[180px] mx-auto h-auto sm:w-[240px] pb-4"
                    />

                    <p className="text-sm text-gray-light">
                        <s>$377</s> $189 (no insurance) or apply your insurance at check out
                    </p>
                </div>
                <div className="space-y-2 lg:mt-4 lg:space-x-4">
                    <button
                        className="btn-primary w-full lg:w-[48%] px-5 py-4 text-lg lg:mt-2"
                        onClick={() => {
                            dispatch(setAssessmentStep('create-account'));

                            ReactGA.event({
                                category: 'User',
                                action: 'Assessment Result',
                                label: 'Continue_Result',
                            });

                            ReactGA.event({
                                category: 'User',
                                action: 'Assessment Result',
                                label: 'Continue_NextSteps',
                            });

                            posthog?.capture('Answered a Question', {
                                question: 'Assessment Result',
                                answer: 'Continue to Create Account',
                            });
                        }}>
                        Get Started
                    </button>
                    <button
                        className="btn-shell bg-gray-darker w-full lg:w-[48%] px-5 py-4 text-lg lg:mt-2"
                        onClick={() => {
                            setModalOpen(true);
                            posthog?.capture('Learn More About HST');
                        }}>
                        Learn More
                    </button>
                </div>
            </div>
            <Modal showClose={true} isOpen={modalOpen} closeHandler={() => setModalOpen(false)}>
                <div className="space-y-4">
                    <p className="xs:text-lg">
                        Home sleep studies are used to diagnose sleep apnea and determine treatment
                        options.
                    </p>
                    <p>We've made the process easy:</p>
                    <ul className="list-disc list-outside pl-4 space-y-2 text-xs xs:text-sm">
                        <li>Order your home sleep test (insurance coverage may apply)</li>
                        <li>Complete it at home on your own time</li>
                        <li>GEM SLEEP clinicians interpret your data (within 1 week)</li>
                        <li>Receive a full report and prescription (if necessary)</li>
                        <li>
                            Order treatment through GEM or take your prescription wherever you
                            choose
                        </li>
                    </ul>
                </div>
            </Modal>
        </motion.div>
    );
}

function VersionC() {
    const dispatch = useDispatch();
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <motion.div
            initial={{ opacity: 0, translateX: '20%' }}
            animate={{ opacity: 1, translateX: 0 }}
            exit={{ opacity: 0, translateX: '-20%' }}
            transition={{ ease: 'linear' }}
            style={{ backgroundImage: `url(${portalDesktop})` }}
            className="absolute right-0 top-0 w-full h-full bg-center bg-cover">
            <div className="absolute right-0 top-0 backdrop-blur-sm w-full h-full">
                <div className="max-w-4xl mx-auto p-8 space-y-3 mt-20 bg-gray-darker bg-opacity-95">
                    <div className="pr-0 lg:pr-8">
                        <h4 className="mb-3 font-heading text-4xl text-purple-fair lg:mb-6">
                            Quiz Results Ready
                        </h4>
                        <h2 className="text-lg text-gray-light lg:mb-5">
                            Based on your answers, you may be suffering from Sleep Apnea.{' '}
                            <span className="text-gem-green">We can help.</span>
                        </h2>
                    </div>

                    <div className="flex flex-col text-sm pl-0 space-y-4 lg:space-y-0">
                        <div className="text-lg space-y-2 mb-2 text-center">
                            <p className="font-bold text-white text-lg lg:text-3xl">
                                Recommended for you:
                            </p>
                            <p className="font-bold font-heading text-5xl text-gem-green lg:text-8xl">
                                Get a sleep study.
                            </p>
                            <img
                                src={watchpatImageSrc}
                                alt="Sleep study"
                                className="w-[180px] mx-auto h-auto sm:w-[240px] pb-4"
                            />

                            <p className="text-sm text-gray-light">
                                <s>$377</s> $189 (no insurance) or apply your insurance at check out
                            </p>
                        </div>
                        <div className="space-y-2 lg:mt-4 lg:space-x-4">
                            <button
                                className="btn-primary w-full lg:w-[48%] px-5 py-4 text-lg lg:mt-2"
                                onClick={() => {
                                    dispatch(setAssessmentStep('create-account'));

                                    ReactGA.event({
                                        category: 'User',
                                        action: 'Assessment Result',
                                        label: 'Continue_Result',
                                    });

                                    ReactGA.event({
                                        category: 'User',
                                        action: 'Assessment Result',
                                        label: 'Continue_NextSteps',
                                    });

                                    posthog?.capture('Answered a Question', {
                                        question: 'Assessment Result',
                                        answer: 'Continue to Create Account',
                                    });
                                }}>
                                Get Started
                            </button>
                            <button
                                className="btn-shell bg-gray-darker w-full lg:w-[48%] px-5 py-4 text-lg lg:mt-2"
                                onClick={() => {
                                    setModalOpen(true);
                                    posthog?.capture('Learn More About HST');
                                }}>
                                Learn More
                            </button>
                        </div>
                    </div>
                    <Modal
                        showClose={true}
                        isOpen={modalOpen}
                        closeHandler={() => setModalOpen(false)}>
                        <div className="space-y-4">
                            <p className="xs:text-lg">
                                Home sleep studies are used to diagnose sleep apnea and determine
                                treatment options.
                            </p>
                            <p>We've made the process easy:</p>
                            <ul className="list-disc list-outside pl-4 space-y-2 text-xs xs:text-sm">
                                <li>Order your home sleep test (insurance coverage may apply)</li>
                                <li>Complete it at home on your own time</li>
                                <li>GEM SLEEP clinicians interpret your data (within 1 week)</li>
                                <li>Receive a full report and prescription (if necessary)</li>
                                <li>
                                    Order treatment through GEM or take your prescription wherever
                                    you choose
                                </li>
                            </ul>
                        </div>
                    </Modal>
                </div>
            </div>
        </motion.div>
    );
}

function VersionD() {
    const dispatch = useDispatch();

    return (
        <motion.div
            initial={{ opacity: 0, translateX: '20%' }}
            animate={{ opacity: 1, translateX: 0 }}
            exit={{ opacity: 0, translateX: '-20%' }}
            transition={{ ease: 'linear' }}
            className="max-w-8xl mx-auto grid grid-cols-1 gap-4 lg:gap-8 lg:grid-cols-2">
            <h4 className="font-heading text-3xl text-purple-fair lg:col-span-2">QUIZ RESULTS</h4>
            <div className="pr-0 lg:pr-8">
                <h2 className="font-heading text-4xl font-bold text-white lg:mb-5 lg:text-7xl">
                    YOU ARE AT RISK OF HAVING SLEEP APNEA. NEXT STEP: COMPLETE A HOME SLEEP STUDY.
                </h2>
                <img
                    src={watchpatImageSrc}
                    alt="Sleep study"
                    className="w-[180px] mx-auto h-auto sm:w-[240px] pb-4"
                />
            </div>

            <div className="lg:space-y-8 flex flex-col-reverse lg:flex-col">
                <div className="text-sm space-y-4 lg:text-lg">
                    <p className="text-lg font-bold text-gray-light lg:text-xl">
                        How does the test work?
                    </p>

                    <p>
                        The process with GEM SLEEP is <b>easy</b> and <b>quick</b>.
                    </p>

                    <p>
                        Create a GEM account, order your home sleep test (many insurances accepted),
                        complete at home. Get expert clinician reviewed results and recommendations
                        back within a week.
                    </p>

                    <p className="text-lg font-bold text-gray-light lg:text-xl">
                        What if I am diagnosed?
                    </p>

                    <p>GEM offers many treatment options, including personalized support.</p>
                </div>
                <button
                    className="btn-primary w-full px-5 py-4 text-lg mb-4"
                    onClick={() => {
                        dispatch(setAssessmentStep('create-account'));

                        ReactGA.event({
                            category: 'User',
                            action: 'Assessment Result',
                            label: 'Continue_Result',
                        });

                        ReactGA.event({
                            category: 'User',
                            action: 'Assessment Result',
                            label: 'Continue_NextSteps',
                        });

                        posthog?.capture('Answered a Question', {
                            question: 'Assessment Result',
                            answer: 'Continue to Create Account',
                        });
                    }}>
                    CONTINUE
                </button>
            </div>
        </motion.div>
    );
}

function HasSleepApnea() {
    //Get variant information for A/B Testing
    const variant = useFeatureFlagVariantKey('assessment-change-v2');

    if (variant === 'version-e') {
        return <VersionE />;
    } else if (variant === 'version-d') {
        return <VersionD />;
    } else if (variant === 'version-c') {
        return <VersionC />;
    } else {
        return <Control />;
    }
}

export default HasSleepApnea;
